import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import useDisclosure from '../../../hooks/useDisclosure';
import { paths } from '../../../routes/paths';
import Icon from '../../ui/Icon/Icon';
import UserSettingsModal from '../../user/UserSettingsModal/UserSettingsModal';
import styles from './UserMenu.module.css';

// Avatar button in the top bar -> dropdown with profile + settings + logout.
export default function UserMenu() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const settings = useDisclosure();

  if (!user) return null;

  const initial = (user.name || user.email || '?').charAt(0).toUpperCase();

  const handleLogout = async () => {
    setOpen(false);
    await logout();
    navigate(paths.login, { replace: true });
  };

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={styles.avatarBtn}
        onClick={() => setOpen((v) => !v)}
        aria-label="User menu"
      >
        {user.avatarUrl ? (
          <img src={user.avatarUrl} alt={user.name} className={styles.avatarImg} />
        ) : (
          <span className={styles.avatarFallback}>{initial}</span>
        )}
      </button>

      {open && (
        <>
          <div className={styles.backdrop} onClick={() => setOpen(false)} />
          <div className={styles.dropdown}>
            <div className={styles.identity}>
              <span className={styles.name}>{user.name || 'unnamed'}</span>
              <span className={styles.email}>{user.email}</span>
            </div>
            <button
              type="button"
              className={styles.item}
              onClick={() => {
                setOpen(false);
                settings.open();
              }}
            >
              <Icon name="Settings" size={14} />
              Settings
            </button>
            <button
              type="button"
              className={`${styles.item} ${styles.itemDanger}`}
              onClick={handleLogout}
            >
              <Icon name="LogOut" size={14} />
              Log out
            </button>
          </div>
        </>
      )}

      <UserSettingsModal isOpen={settings.isOpen} onClose={settings.close} />
    </div>
  );
}
